import { useState } from "react";
import '../../css/FAQSection.css'
const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "چگونه می‌توانم در دوره‌ها ثبت‌نام کنم؟",
      answer:
        "برای ثبت‌نام در دوره‌ها، می‌توانید از طریق سایت اقدام کنید یا با شماره تماس ما تماس بگیرید.",
    },
    {
      question: "آیا امکان بازپرداخت وجود دارد؟",
      answer:
        "بله، ما ضمانت بازگشت وجه تا 24 ساعت پس از شروع دوره ارائه می‌دهیم.",
    },
    {
      question: "آیا دوره‌ها به صورت آنلاین برگزار می‌شوند؟",
      answer:
        "بله، تمامی دوره‌ها به صورت آنلاین و از طریق پلتفرم اختصاصی ما برگزار می‌شوند.",
    },
  ];

  return (
    <section className="max-w-2xl mx-auto p-6 rounded-xl shadow-md Fq mt-10">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">سوالات متداول</h2>
        <p className="text-gray-500">پاسخ سوالات رایج شما</p>
      </div>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border-b border-gray-200 pb-4"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center text-right text-gray-800 font-medium focus:outline-none"
            >
              <span>{faq.question}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`w-5 h-5 transform transition-transform duration-300 ${
                  openIndex === index ? "rotate-180" : "rotate-0"
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            {openIndex === index && (
              <div className="mt-3 text-gray-600 leading-relaxed">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
